export default __webpack_public_path__ + "static/media/disc.601740d6.svg";